import { render, staticRenderFns } from "./courier-shifts.vue?vue&type=template&id=698f3be6&scoped=true&"
import script from "./courier-shifts.js?vue&type=script&lang=js&"
export * from "./courier-shifts.js?vue&type=script&lang=js&"
import style0 from "./courier-shifts.scss?vue&type=style&index=0&id=698f3be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698f3be6",
  null
  
)

export default component.exports